
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarmiajaipur() {



  const cardData =
  {
    keyword: 'Patient Warming Blankets in Jaipur',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Blankets in Jaipur',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warming Blankets in Jaipur, ensuring effective temperature management for patients during surgeries and critical care. Our Wallabies Warm Care blankets are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warming blankets are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Jaipur to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
  {
    "title": "Patient Warming Blankets in Jaipur",
    "description": "Pharmacle Health Care Private Limited provides high-quality patient warming blankets in Jaipur, designed to ensure effective heat retention and prevent perioperative hypothermia. Our blankets enhance surgical safety and patient comfort in hospitals and clinics."
  },
  {
    "title": "Advanced Forced-Air Warming Blankets",
    "description": "Pharmacle Health Care Private Limited offers advanced forced-air warming blankets that deliver uniform heat distribution. Ideal for surgical wards, ICUs, and recovery rooms, these blankets help maintain normothermia and support faster patient recovery."
  },
  {
    "title": "Disposable Patient Warming Blankets",
    "description": "Our disposable patient warming blankets provide a hygienic, single-use solution for maintaining body temperature in medical facilities. Pharmacle Health Care Private Limited ensures infection-free patient care with superior thermal performance."
  },
  {
    "title": "Neonatal Warming Blankets",
    "description": "Specially designed for NICUs and maternity wards in Jaipur, Pharmacle Health Care Private Limited’s neonatal warming blankets offer gentle, precise temperature control, safeguarding premature and newborn babies from hypothermia."
  },
  {
    "title": "Surgical Patient Warming Blankets",
    "description": "Pharmacle Health Care Private Limited supplies surgical patient warming blankets that are essential for operating rooms. These blankets reduce intraoperative temperature fluctuations, minimize complications, and promote smoother recovery."
  },
  {
    "title": "ICU Patient Warming Blankets",
    "description": "Our ICU patient warming blankets deliver consistent heat regulation for critically ill patients. Pharmacle Health Care Private Limited ensures effective thermal support that stabilizes body temperature and enhances recovery outcomes."
  },
  {
    "title": "Emergency Hypothermia Prevention Blankets",
    "description": "Pharmacle Health Care Private Limited provides emergency hypothermia prevention blankets for trauma and critical care. These blankets prevent rapid heat loss and ensure life-saving thermal stabilization in emergencies."
  },
  {
    "title": "Veterinary Patient Warming Blankets",
    "description": "Extending our innovation to veterinary care, Pharmacle Health Care Private Limited offers warming blankets that provide safe and effective temperature control for animals during treatments and surgeries."
  },
  {
    "title": "Reusable Patient Warming Blankets",
    "description": "Our reusable patient warming blankets are cost-effective and environmentally friendly. Pharmacle Health Care Private Limited ensures long-lasting performance without compromising on safety or patient comfort."
  },
  {
    "title": "Preoperative & Postoperative Warming Blankets",
    "description": "Pharmacle Health Care Private Limited’s preoperative and postoperative warming blankets maintain consistent warmth before and after surgery, ensuring improved patient safety, comfort, and accelerated recovery."
  }
],


"services": [
    {
        "name": "Patient Warming Blankets Jaipur",
        "description": "Pharmacle Health Care Private Limited offers patient warming blankets in Jaipur, designed to maintain a stable body temperature for patients during surgeries and recovery. These blankets help prevent hypothermia and ensure a comfortable and safe experience for patients."
    },
    {
        "name": "Jaipur Forced Air Warming Blankets",
        "description": "We provide forced air warming blankets in Jaipur, which offer effective temperature regulation by providing consistent warm air circulation. Ideal for surgical procedures, these blankets ensure that patients maintain a safe body temperature during medical treatments."
    },
    {
        "name": "Warming Blankets Jaipur",
        "description": "Our warming blankets in Jaipur are designed to provide controlled warmth to patients during surgeries, critical care, and recovery. These blankets ensure patient comfort and safety by preventing temperature fluctuations and hypothermia."
    },
    {
        "name": "Patient Thermoregulation Blankets Jaipur",
        "description": "Pharmacle Health Care offers thermoregulation blankets in Jaipur that help maintain a stable and safe body temperature for patients during medical procedures. These blankets provide an optimal solution for patient warming and temperature management."
    },
    {
        "name": "Jaipur Medical Warming Blankets",
        "description": "We supply medical warming blankets in Jaipur, specifically designed for use in hospitals and healthcare facilities. These blankets are crucial for maintaining a stable body temperature and preventing hypothermia during surgeries and critical care."
    },
    {
        "name": "Jaipur Temperature Regulation Blankets",
        "description": "Our temperature regulation blankets in Jaipur help manage and maintain the body temperature of patients during surgical procedures and recovery. These blankets provide a safe, effective, and comfortable solution for patient warming."
    },
    {
        "name": "Warming Blankets for Surgical Use Jaipur",
        "description": "We offer warming blankets for surgical use in Jaipur, ensuring that patients remain at a comfortable temperature during surgery. These blankets are essential for preventing hypothermia and improving patient recovery in post-surgical care."
    }
],
"tableData": [
    ["- Patient Warming Blankets Jaipur", "- Jaipur Forced Air Warming Blankets"],
    ["- Warming Blankets Jaipur", "- Patient Thermoregulation Blankets Jaipur"],
    ["- Jaipur Medical Warming Blankets", "- Jaipur Temperature Regulation Blankets"],
    ["- Warming Blankets for Surgical Use Jaipur"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient warming blankets in Jaipur, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, improving patient safety in hospitals and clinics across Jaipur."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a wide range of patient warming blankets in Jaipur, including forced air warming blankets and temperature control systems. Our solutions are designed to meet the needs of both surgical procedures and critical care, ensuring your patients remain comfortable and safe during their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming blankets are manufactured to the highest standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our equipment provides optimal reliability for continuous use in medical settings across Jaipur."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our warming blankets provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Jaipur are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming blankets in Jaipur are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs and improve overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming blankets are designed for easy integration with existing medical systems in Jaipur. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Jaipur to help healthcare facilities choose the right patient warming blankets for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and delivers the best possible care."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient warming blankets are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Jaipur receives the highest standard of care."
    }
]








  }


  const faqData = [
    { question: "What are Patient Warming Blankets?", answer: "Patient Warming Blankets are specially designed blankets that provide controlled warm air to maintain a patient’s body temperature during surgeries, medical procedures, or treatments." },
    { question: "How do Patient Warming Blankets work?", answer: "These blankets work by circulating warm air through them, which helps regulate the patient's body temperature, preventing hypothermia and ensuring comfort during medical procedures." },
    { question: "Are Patient Warming Blankets available in Jaipur?", answer: "Yes, Pharmacle Health Care Private Limited offers Patient Warming Blankets in Jaipur, providing healthcare facilities with high-quality solutions to manage patient body temperature during treatments." },
    { question: "What are the benefits of using Patient Warming Blankets?", answer: "The benefits include preventing hypothermia, reducing surgical complications, enhancing patient comfort, and improving recovery times by maintaining the patient’s body temperature within the normal range." },
    { question: "How long can a Patient Warming Blanket maintain a patient’s temperature?", answer: "The Patient Warming Blanket can maintain the patient’s body temperature for the entire duration of the medical procedure or treatment, adjusting as necessary to ensure optimal warmth." },
    { question: "Are Patient Warming Blankets easy to use?", answer: "Yes, they are designed to be user-friendly, with simple controls for adjusting the temperature and easy setup for healthcare professionals to use in various clinical settings." },
    { question: "Can Patient Warming Blankets be used in all types of surgeries?", answer: "Yes, Patient Warming Blankets are versatile and can be used for many types of surgeries and medical procedures, especially those where maintaining the patient’s body temperature is crucial." },
    { question: "Are Patient Warming Blankets safe for all patients?", answer: "Yes, the blankets are safe for most patients. However, they should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and prevent overheating." },
    { question: "How can I purchase Patient Warming Blankets in Jaipur?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will guide you through the purchase process and arrange delivery to healthcare facilities in Jaipur." },
    { question: "Does Pharmacle Health Care provide support for Patient Warming Blankets?", answer: "Yes, we offer complete support for Patient Warming Blankets, including installation, staff training, and ongoing maintenance services to ensure they perform optimally." }
  ];
  
  const testimonialsData = [
    {
      text: 'We’ve been using Patient Warming Blankets from Pharmacle Health Care in our Jaipur hospital. The blankets are effective at maintaining body temperature and improving patient comfort during surgeries, especially for long procedures.',
      name: 'Dr. Sanjay Agarwal',
    },
    {
      text: 'Pharmacle Health Care’s Patient Warming Blankets have significantly improved the comfort and safety of our patients in Jaipur. They’re easy to use and ensure that patients remain at an optimal body temperature during treatments.',
      name: 'Dr. Neha Verma',
    }
  ];
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming Blankets in Jaipur",
    "description": "Find high-quality Patient Warming Blankets in Jaipur for effective patient thermoregulation during medical procedures. Our warming blankets ensure optimal comfort and temperature regulation, ideal for surgical use and hospital settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "1963"
    }
  };



  return (
    <div>
  
  <Helmet>
    <title>Patient Warming Blankets in Jaipur | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find high-quality Patient Warming Blankets in Jaipur for patient thermoregulation and temperature control. Ideal for surgical use and medical settings. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming Blankets Jaipur, Jaipur Forced Air Warming Blankets, Warming Blankets Jaipur, Patient Thermoregulation Blankets Jaipur, Jaipur Medical Warming Blankets, Jaipur Temperature Regulation Blankets, Warming Blankets for Surgical Use Jaipur"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarmiajaipur;